<ng-container *ngIf="loadingService.FULL_LOADING">
    <div class="container-fluid d-flex justify-content-center">
        <div class="spinner-border align-self-center text-white"></div>
    </div>
</ng-container>
